import { isUndefined } from 'ramda-adjunct'

export const getYoutubeIframeApiSingleton = async (): Promise<typeof globalThis.YT> => {
  if (!isUndefined(globalThis.YT)) {
    return globalThis.YT
  }

  const YoutubeIframePromise = new Promise<typeof globalThis.YT>((res) => {
    ;(globalThis as any).onYouTubeIframeAPIReady = () => res(globalThis.YT)
  })

  const tag = document.createElement('script')
  tag.src = 'https://www.youtube.com/iframe_api'
  document.head.append(tag)

  return await YoutubeIframePromise
}
